import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root:{
    flexGrow: 1,
  },
  text:{
    fontSize: 30,
    textAlign: 'center',
    color:'#444444',
  },
})

class PageNotFound extends Component{
  render(){
    const { classes } = this.props;
    return (

      <ReactCSSTransitionGroup
        className="container result"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
      >

      <div className={classes.root}>
        <h3 className={classes.text}>恐れ入りますがお探しのページはご利用いただけません。</h3>
        </div>
      </ReactCSSTransitionGroup>
    );
  }
}

export default withStyles(styles, { withTheme: true })(PageNotFound);



// WEBPACK FOOTER //
// ./src/components/PageNotFound.js